import { fg } from '@atlassian/jira-feature-gating';

const isQueryByStatusFieldDirectlyEnabled = {
	get(): boolean {
		return fg('jiv-20953-query-by-status-field-directly');
	},
};

export default isQueryByStatusFieldDirectlyEnabled;
